import React, { useState } from 'react';
import axios from 'axios';
import './App.css';

function App() {
  const [formData, setFormData] = useState({
    fullName: 'Phan Thị Phương Mai',
    position: 'Administrator',
    email: 'phan.thi.phuong.mai@mqsolutions.vn',
    phone: '(+84)349629857',
    teams: 'live.phan.thi.phuong.mai'
  });
  const [signature, setSignature] = useState('');
  const [showPreview, setShowPreview] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post('https://signature.mqsolutions.vn/api/generate-signature', formData);
      setSignature(response.data.signature);
      setShowPreview(true);
    } catch (error) {
      console.error('Error generating signature:', error);
    }
  };

  const handleReset = () => {
    setShowPreview(false);
    setSignature('');
  };

  const downloadSignature = () => {
    const element = document.createElement('a');
    const file = new Blob([signature], { type: 'text/html' });
    element.href = URL.createObjectURL(file);
    element.download = 'mq-signature.html';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  return (
    <div className="app">
      {!showPreview ? (
        <>
          <h1>Tạo chữ ký MQ ICT Solutions</h1>

          <form onSubmit={handleSubmit} className="form-container">
            <div className="form-group">
              <label>Họ Tên:</label>
              <input
                type="text"
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Chức vụ/bộ phận:</label>
              <input
                type="text"
                name="position"
                value={formData.position}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Email:</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Số điện thoại:</label>
              <input
                type="text"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </div>

            <button type="submit" className="generate-btn">Tạo chữ ký</button>
          </form>
        </>
      ) : (
        <div className="container">
          <h2>Xem trước chữ ký:</h2>
          <img src="/logo.png" alt="Logo" className="logo" />
          <p style={{ fontSize: '10px', fontWeight: '700' }}>{formData.fullName} / {formData.position}</p>
          <p style={{ fontSize: '10px', fontWeight: '700', marginTop: '-6px' }}><a href={`mailto:${formData.email}`}>{formData.email}</a></p>
          <p style={{ fontSize: '10px', fontWeight: '700', marginTop: '-5px' }}>{formData.phone}</p>

          <div className="content">
            <div className="info">
              <div>
                <b>MQ ICT SOLUTIONS (Vietnam)</b><br />
                Tel: (+84)-4-6291-9538 | Website: <a style={{ textDecoration: 'none' }} href="https://mqsolutions.vn">https://mqsolutions.vn</a><br />
                <span style={{ color: 'red' }}>Headquarter Office:</span> 119-121 Nguyen Huu Tho, Dai Kim Ward, Hoang Mai District, Hanoi, Vietnam
              </div>
            </div>
          </div>

          <div className="notice">
            <p style={{ paddingTop: "10px", fontFamily: "Helvetica", color: "#0000ff", fontSize: "9px", lineHeight: "12px" }}>
              <b>IMPORTANT NOTICE:</b>
              The information in this e-mail and any attached files are CONFIDENTIAL and may be legally privileged or prohibited from disclosure and unauthorized use. The views of the author may not necessarily reflect those of the Company.
              It is intended solely for the addressee or the employee or agent responsible for delivering such materials to the addressee. If you have received this message in error please return it to the sender then delete the email and destroy any copies of it. If you are not the intended recipient, any form of reproduction, dissemination, copying, disclosure, modification, distribution and/or publication or any action taken or omitted to be taken in reliance upon this message or its attachments is prohibited and may be unlawful.
              At present the integrity of e-mail across the Internet cannot be guaranteed and messages sent via this medium are potentially at risk. All liability is excluded to the extent permitted by law for any claims arising as a result of the use of this medium to transmit information by or to MQ ICT Solutions.
            </p>
          </div>

          <div className="buttons">
            <button onClick={downloadSignature} className="download-btn">Download</button>
            <button onClick={handleReset} className="reset-btn">Làm lại</button>
          </div>
        </div>
      )}
    </div>
  )
}

export default App;